import React, { useState } from "react";
import { Form, Input, Modal, Row, Select, Typography } from "antd";
import { Color, NewProductAttribute } from "../../../../../domain";
import { logger } from "../../../../../utils";
import I18n from "../../../../i18n";
import { useAppSelector } from "../../../../../application/store";

const { useForm, Item } = Form;

type NewAttributeModalProps = {
  visible: boolean;
  onClose: () => void;
  onOk: (attribute: NewProductAttribute) => void;
};

const NewAttributeModal: React.FC<NewAttributeModalProps> = ({
  visible,
  onClose,
  onOk,
}) => {
  const { colors } = useAppSelector((state) => state.colors);
  const [form] = useForm();

  const [color, setColor] = useState<Color | undefined>();

  const submit = async () => {
    try {
      await form.validateFields();
      if (color === undefined) return;
      onOk({
        color: color,
        count: form.getFieldValue("count"),
        price: form.getFieldValue("price"),
        size: form.getFieldValue("size"),
        sizeDescription: form.getFieldValue("sizeDescription"),
      });
      onClose();
    } catch (error) {
      logger.error(error);
    }
  };

  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      onOk={submit}
      bodyStyle={{ paddingBottom: 0 }}
    >
      <Form form={form}>
        <Item
          name="size"
          label={I18n.product.size}
          required
          rules={[
            {
              required: true,
              validateTrigger: "onSubmit",
              type: "string",
            },
          ]}
        >
          <Input name="size" />
        </Item>
        <Item
          name="sizeDescription"
          label={I18n.product.sizeDescription}
          required
          rules={[
            {
              required: true,
              validateTrigger: "onSubmit",
              type: "string",
            },
          ]}
        >
          <Input name="sizeDescription" />
        </Item>
        <Item name="color" label={I18n.product.color} required>
          <Select
            aria-required
            onChange={(value) =>
              setColor(colors.find((color) => color.id === value))
            }
          >
            {colors.map((color) => {
              return (
                <Select.Option value={color.id}>
                  <Row align="middle">
                    <span
                      style={{
                        backgroundColor: color.color,
                        width: 24,
                        height: 24,
                        marginLeft: 16,
                      }}
                    >
                      {" "}
                    </span>
                    <Typography.Text>{color.title}</Typography.Text>
                  </Row>
                </Select.Option>
              );
            })}
          </Select>
        </Item>
        <Item
          name="price"
          label={I18n.product.price}
          required
          rules={[
            {
              required: true,
              validateTrigger: "onSubmit",
              type: "integer",
            },
          ]}
        >
          <Input
            name="price"
            onChange={(event) => {
              form.setFields([
                { name: "price", value: parseInt(event.target.value) },
              ]);
            }}
          />
        </Item>
        <Item
          name="count"
          label={I18n.product.count}
          required
          rules={[
            {
              required: true,
              validateTrigger: "onSubmit",
              type: "integer",
            },
          ]}
        >
          <Input
            name="count"
            onChange={(event) => {
              form.setFields([
                { name: "count", value: parseInt(event.target.value) },
              ]);
            }}
          />
        </Item>
      </Form>
    </Modal>
  );
};

export default NewAttributeModal;
